module.exports = __webpack_public_path__ + "static/media/photo86.09ad26fc.jpg";